module.exports = __webpack_public_path__ + "media/images/grunge-be31085107740aa8b216cadfb51db391.png";